export const formatK = (num: number): string => {
  return num >= 1000
    ? `${(num / 1000).toFixed(num % 1000 === 0 ? 0 : 1)}k`
    : `${num}`
}
